export default __webpack_public_path__ + "static/media/linked.3a130dea.png";